import {
  Injectable,
  WritableSignal,
  computed,
  effect,
  signal,
} from '@angular/core';
import Membership from '../models/Membership.model';
import { PBService } from './pocketbase.service';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  private pbService: PBService;
  public availableMemberships: WritableSignal<Membership[]> = signal([]);
  public selectedMembership: WritableSignal<Membership | null> = signal(null);

  public selectedVenueID = computed(
    () => this.selectedMembership()?.VenueID || null
  );

  public hasMultipleVenues = computed(
    () => this.availableMemberships().length > 1
  );
  public hasMultipleCustomers = this.hasMultipleVenues;

  constructor(pbService: PBService) {
    this.pbService = pbService;

    effect(() => {
      const currentID = this.selectedVenueID();
      this.pbService.setCurrentVenueID(currentID);
    });
  }

  async loadMemberships(): Promise<void> {
    if (!this.pbService.isAuthenticated()) {
      console.warn(
        'SettingsService: User not authenticated. Skipping membership load.'
      );
      return;
    }

    try {
      const memberships = await this.pbService.getMemberships();
      this.availableMemberships.set(memberships);

      if (memberships.length > 0) {
        const savedMembershipId = localStorage.getItem('selectedMembershipId');
        const savedMembership = memberships.find(
          (m) => m.id === savedMembershipId
        );

        if (savedMembership) {
          this.selectedMembership.set(savedMembership);
        } else {
          this.selectedMembership.set(memberships[0]);
        }
      } else {
        this.selectedMembership.set(null);
      }
    } catch (error) {
      console.error('Failed to load memberships:', error);
    }
  }

  setCurrentMembership(membership: Membership): void {
    if (membership && membership.id !== this.selectedMembership()?.id) {
      this.selectedMembership.set(membership);
      localStorage.setItem('selectedMembershipId', membership.id);
      window.location.reload();
    }
  }

  clear(): void {
    this.availableMemberships.set([]);
    this.selectedMembership.set(null);
    localStorage.removeItem('selectedMembershipId');
  }
}
